import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
@Injectable()
export class SMSService {

    apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    public sendSMS(smsObj) 
    {


        let url = `${ this.apiUrl }/api/v1/send-sms`;
        
        return this.http.post(url, smsObj);
    }  
  
    
}
